module.exports = __webpack_public_path__ + "img/3.8a0a6b2e.png";